import { IconButton, Tooltip } from '@material-ui/core';
import { CloseSmallIcon } from '@images/icons';
import { translate } from '@utils';

interface MultipleRemoveButtonProps {
  handleDelete: (id: string) => void;
  id: string;
}

const MultipleRemoveButton = (props: MultipleRemoveButtonProps) => {
  const { handleDelete, id } = props;

  return (
    <div className="remove-button-container">
      <Tooltip title={translate('remove')} arrow>
        <IconButton
          size="small"
          color="primary"
          data-testid="remove-button"
          onClick={() => handleDelete(id)}
        >
          <CloseSmallIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export { MultipleRemoveButton };
